import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import contentBlocks from '../../config/contentBlocks';
// import Container from '../Container';
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/effect-fade/effect-fade.min.css';
import 'swiper/modules/autoplay/autoplay.min.css';
// import 'swiper/modules/scrollbar/scrollbar.min.css';
import Arrow from '../../svg/arrow-black.svg';
import Squiggle from '../../svg/brush.svg';

const CarouselContainer = styled.div`
  padding-bottom: 2rem;
  max-width: 80%;
  margin: 0 auto;

  .swiper {
    ${props =>
      props.inversePagination ? 'padding-top: 4rem;' : 'padding-bottom: 2rem;'}
  }

  .swiper-fade .swiper-slide {
    opacity: 0 !important;
  }

  .swiper-fade .swiper-slide-active,
  .swiper-fade .swiper-slide-active .swiper-slide-active {
    opacity: 1 !important;
  }

  .swiper-pagination {
    ${props => props.inversePagination && 'bottom: auto !important; top: 10px;'}
  }

  .swiper-pagination-bullet {
    width: 30%;
    max-width: 200px;
    text-align: center;
    height: auto;
    border-radius: 0;
    background: none;
    opacity: 1;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.assfault};
    transition: color 100ms ease-in;

    // &::after {
    //   content: '';
    //   display: block;
    //   height: 4px;
    //   width: 100%;
    //   background-color: black;
    // }

    &:hover {
      color: ${({ theme }) => theme.colors.briangerine};
    }
  }

  .swiper-pagination-bullet-active {
    background-image: url(${Squiggle});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    background-size: contain;
    font-weight: bold;
    color: white;

    &:hover {
      color: white;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    background-image: url(${Arrow});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    background-size: contain;
    transform: rotate(-90deg);
  }

  .swiper-button-prev {
    transform: rotate(90deg);
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    display: none;
  }
`;

const CarouselItem = styled.div`
  /* display: flex; */
  // width: ${props => (1 / props.itemsVisible) * 100}%;
  // ${props => props.itemWidth && 'width: ' + props.itemWidth};
  // flex: 0 0 auto;
  padding: 2rem 2rem 8rem;

  *:first-child {
    margin-top: 0;
  }
`;

const CarouselBlock = ({ fields, ...props }) => {
  const { collection, itemsVisible, inversePagination } = fields;

  const pagination = {
    clickable: true,
    renderBullet: function(index, className) {
      return '<span class="' + className + '">STAGE ' + (index + 1) + '</span>';
    },
  };

  return (
    <CarouselContainer inversePagination={inversePagination}>
      <Swiper
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        effect="fade"
        navigation
        pagination={pagination}
        loop
        autoplay
        // scrollbar={{ draggable: true }}
        // onSlideChange={() => console.log('slide change')}
        // onSwiper={swiper => console.log(swiper)}
      >
        {collection &&
          collection.length &&
          collection.map((gridItem, i) => {
            const { sys } = gridItem;
            let itemContentType = null;
            let contentId = i;
            let fields = gridItem;

            if (sys) {
              itemContentType =
                sys.contentType &&
                sys.contentType.sys &&
                sys.contentType.sys.id;
              contentId = sys.id;
            } else if (gridItem.type) {
              /** This is a Netlify content structure */
              itemContentType = gridItem.type;
              fields = {
                fields: {
                  ...gridItem,
                },
              };
            }

            if (!itemContentType) {
              return false;
            }

            const ContentBlock = contentBlocks[itemContentType];

            return (
              <SwiperSlide>
                <CarouselItem
                  gridGap={3}
                  itemsVisible={itemsVisible}
                  key={contentId}
                  index={i}
                  numberOfItems={collection.length}
                >
                  {ContentBlock && (
                    <ContentBlock {...fields} fullWidth isNested />
                  )}
                </CarouselItem>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </CarouselContainer>
  );
};

CarouselBlock.propTypes = {
  fields: PropTypes.shape({
    collection: PropTypes.array,
    itemsVisible: PropTypes.number,
    inversePagination: PropTypes.bool,
  }).isRequired,
};

CarouselBlock.defaultProps = {
  fields: {
    collection: [],
    itemsVisible: 1,
    inversePagination: false,
  },
};

export default CarouselBlock;
